import React from "react";
import styles from "./InlinePointsComponent.module.css";
const InlinePointsComponent = (props) => {
  return (
    <div className={styles.deactivate_container}>
      <ul>
        <li>
          {props?.title && (
            <span
              // className={styles.deactivate_title}
              style={{
                color: props?.color ? props?.color : "var(--black-color)",
                fontFamily: props?.fontFamily
                  ? props?.fontFamily
                  : "Poppins-bold",
                fontSize: props?.fontSize
                  ? props?.fontSize
                  : "var(--paragraph-font-size)",
              }}
            >
              {props?.title}
            </span>
          )}
          <span
            // className={styles.deactivate_text}
            style={{
              color: props?.color ? props?.color : "var(--black-color)",
              fontFamily: props?.fontFamily
                ? props?.fontFamily
                : "Poppins-regular",
              fontSize: props?.fontSize
                ? props?.fontSize
                : "var(--paragraph-font-size)",
            }}
          >
            {" "}
            {props?.description}
          </span>
        </li>
      </ul>
    </div>
  );
};

export default InlinePointsComponent;
